module.exports = __webpack_public_path__ + "images/emoji/u7981.6c7d05b204acd4cefd45.png";